import React from 'react';
import classNames from 'classnames';
import EnterpriseNavigation from '../../../../components/EnterpriseNavigation';
import AnalyticsFitlers from '../AnalyticsFitlers';

import './AnalyticsNavigation.styles.scss';
import './AnalyticsNavigation.styles.responsive.scss';

type AnalyticsNavigationProps = {
  className?: string;
};

const AnalyticsNavigation: React.FC<AnalyticsNavigationProps> = (props) => {
  const { className } = props;

  const classes = classNames('analytics-navigation', className);

  return (
    <div className={classes}>
      <EnterpriseNavigation />

      <AnalyticsFitlers />
    </div>
  );
};

export default AnalyticsNavigation;
